import SA from 'actions/dod/dodSecurityActions';

export function dodSecurityUpdateField(f) {
    return { type: SA.UPDATE_DOD_SECURITY_FIELD, payload: f };
}

export function dodSecurityUpdateTitle(t) {
    return { type: SA.UPDATE_DOD_SECURITY_TITLE, payload: t };
}
